import { useEffect } from "react";

function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

// seo: { metaTitle, metaDescription, metaKeywords, ogTitle, ogDescription, ogImage }
export default function useSeo(seo = {}, fallbackTitle = "") {
  useEffect(() => {
    const title = seo.metaTitle || fallbackTitle;
    if (title) document.title = title;
    setMeta("name", "description", seo.metaDescription);
    setMeta("name", "keywords", seo.metaKeywords);
    setMeta("property", "og:title", seo.ogTitle || title);
    setMeta("property", "og:description", seo.ogDescription || seo.metaDescription);
    setMeta("property", "og:image", seo.ogImage);
    setMeta("property", "og:type", "website");
  }, [seo, fallbackTitle]);
}
